<template lang="html">
    <div>
        <estudios/>
    </div>
</template>

<script>
import Estudios from '../components/estudiosComponent'
export default {
    components:{
        Estudios
    }
    
}
</script>

